// extracted by mini-css-extract-plugin
module.exports = {"header":"header--CBSb_","editsIcon":"editsIcon--D2Dac","verison":"verison--THn2w","goBack":"goBack--GwArU"};